import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Column;
